import { createFileRoute } from "@tanstack/react-router"
import { FiGitMerge, FiLayers, FiShare2 } from "react-icons/fi"
import {
  type ProductionModuleCard,
  ProductionModuleHubPage,
} from "../../../../components/WMS/ProductionNavigation/ProductionModuleHubPage"

const cards: ProductionModuleCard[] = [
  {
    title: "Technologie",
    description:
      "Przeglądaj wersje technologii, ich składniki wejściowe i produkty wyjściowe.",
    to: "/WMS/technologies/technologies-list",
    icon: FiLayers,
  },
  {
    title: "Drzewo technologii",
    description:
      "Analizuj zależności materiałowe pomiędzy technologiami i produktami.",
    to: "/WMS/technologies/tree",
    icon: FiGitMerge,
  },
  {
    title: "Przepływy technologiczne",
    description:
      "Twórz i edytuj własne schematy przepływu kolejnych etapów produkcji.",
    to: "/WMS/technologies/flows",
    icon: FiShare2,
  },
]

export const Route = createFileRoute("/_layout/WMS/technologies/")({
  component: TechnologiesHubRoute,
})

function TechnologiesHubRoute() {
  return (
    <ProductionModuleHubPage
      title="Technologie"
      description="Definicje procesów, zależności materiałowe i przepływy technologiczne."
      cards={cards}
    />
  )
}
